import React from "react";
import { useUi, useBlocks } from "@jelly/lesson";
import * as appConfig from "appConfig";
import styles from "./Modals.module.scss";

type ModalProps = Omit<React.ComponentProps<typeof import("@jelly/ui").Modal>, "children">;

export const RearRightSeatModal: React.FC<ModalProps> = (props) => {
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props}>
      <div className={styles.root}>
        <div className={styles.imageWrapper}>
          <div style={{ width: "100%", height: "100%" }}>
            <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/case/case08/interior/modal_rrs.png`} />
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const RearLeftSeatModal: React.FC<ModalProps> = (props) => {
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props}>
      <div className={styles.root}>
        <div className={styles.imageWrapper}>
          <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/case/case08/interior/modal_rls.png`} />
        </div>
      </div>
    </ui.Modal>
  );
};

export const FrontRightSeatModal: React.FC<ModalProps> = (props) => {
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props}>
      <div className={styles.root}>
        <div className={styles.imageWrapper}>
          <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/case/case08/interior/modal_frs.png`} />
        </div>
      </div>
    </ui.Modal>
  );
};
